import { eventEmitter, Events } from "@/utils/eventEmitter";
import { useEffect } from "react";

export function useSubscribeToEvent(
    event: keyof Events,
    eventHandler: () => void,
) {
    useEffect(() => {
        eventEmitter.on(event, eventHandler);

        return () => {
            eventEmitter.off(event, eventHandler);
        };
    }, [event, eventHandler]);
}
